import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

const Root = styled('div')({});
const Chart = styled('div')({
  position: 'relative',
  height: 4,
  width: '100%',
  marginBottom: legacyTheme.spacing.s12,
  backgroundColor: theme.colors.neutral[600],
});
const Indicator = styled('span')(({ value }) => ({
  position: 'absolute',
  left: `${value}%`,
  width: 12,
  height: 12,
  marginLeft: -4,
  marginTop: -4,
  borderRadius: '50%',
  backgroundColor: theme.colors.primary[400],
}));
const Labels = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

const Range = ({ labels, value }) => (
  <Root>
    <Chart>
      <Indicator value={value} />
    </Chart>
    <Labels>
      {labels.map(label => (
        <Typography key={label} color="noir" variant="mono3">
          {label}
        </Typography>
      ))}
    </Labels>
  </Root>
);

Range.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  value: PropTypes.number.isRequired,
};

export default Range;
